import { Button } from '@mentalgrowth/ui-kit-web';
import type { TpButtonProps } from '@mentalgrowth/ui-kit-web';
export const UiKitButton = (props: TpButtonProps) => <Button {...props} data-sentry-element="Button" data-sentry-component="UiKitButton" data-sentry-source-file="index.tsx" />;